// Shared copy for the "some AI calls couldn't be priced" warning. The BE
// excludes unknown-model calls from total_usd, so both the AI Costs page
// summary and the AppLayout headline spend badge surface this rather than
// silently under-counting. Single source so the two surfaces never drift.
export const unpricedMessage = (
  count: number,
  unknownModels: string[],
): string => {
  const models = unknownModels.length
    ? unknownModels.join(", ")
    : "unknown model";
  return `${count} AI call${count === 1 ? "" : "s"} could not be priced (unknown model: ${models}) - excluded from the total.`;
};
